import PropTypes from "prop-types";
import "./styles.scss";

function ChargerInfo(props) {
  const { label, value } = props;
  return (
    <div className="charger-info-row">
      <div className="charger-info-label">{label}</div>
      <div className="charger-info-value">{value}</div>
    </div>
  );
}

ChargerInfo.propTypes = {
  label: PropTypes.string,
  value: PropTypes.string,
};

export default ChargerInfo;
